var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCss = function SvgCss(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 1 3 5h4z",
    fill: "#9aa7b0",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1v5H3v2h10V1z",
    fill: "#9aa7b0",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 16h15V9H1z",
    fill: "#40b6e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12.501C2 11 2.931 10 4.256 10c.946 0 1.294.311 1.713.753l-.542.674C5.077 11.068 4.75 11 4.25 11 3.418 11 3 11.738 3 12.487S3.412 14 4.25 14c.537 0 .802-.107 1.177-.494l.573.638c-.456.525-.803.856-1.775.856C2.949 15 2 14.002 2 12.501zM7.973 11.502c0-.369.311-.502.872-.502H10v-1H8.86C7.778 10 7 10.46 7 11.45c0 .865.42 1.24 1.471 1.466.77.165 1.025.313 1.025.632S9.138 14 8.471 14H7.3v1h1.171c2.029 0 2.029-1 2.029-1.452 0-.632-.48-1.127-1.341-1.401-.862-.274-1.186-.277-1.186-.645zM11.973 11.502c0-.369.311-.502.872-.502H14v-1h-1.14c-1.082 0-1.86.46-1.86 1.45 0 .865.42 1.24 1.471 1.466.77.165 1.025.313 1.025.632s-.358.452-1.025.452H11.3v1h1.171c2.029 0 2.029-1 2.029-1.452 0-.632-.48-1.127-1.341-1.401-.862-.274-1.186-.277-1.186-.645z",
    fill: "#231f20"
  })))));
};
export default SvgCss;